import { FC, useEffect, useRef, useState } from "react";
import Logo from "shared/Logo/Logo";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import HeroSearchFormSmall, {
  SearchTab,
} from "components/HeroSearchFormSmall/HeroSearchFormSmall";
import { Link, useLocation } from "react-router-dom";
import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import AvatarDropdown from "./AvatarDropdown";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import { StaySearchFormFields } from "components/HeroSearchForm/type";
import { useMetadataUser } from "contexts/metadata-user-context";
import { FaWallet } from "react-icons/fa6";
import type { Root as RootProfile } from "services/get-profile";

interface Header3Props {
  className?: string;
  searchEngine?: boolean;
}

export interface UserDataType {
  name: string;
  birthday: string;
  phone: string;
  cpf: string;
}

export interface UserAssinatura {
  id: number;
  nome_plano: string;
  valor_mes: number;
  valor_total: number;
  valor_teto: number;
  assinatura_ativa: number;
  data_escolha: string;
  diarias_disponiveis: number;
  cpf: string;
  email: string;
  nome: string;
  telefone: string;
  email_second: string;
  data_de_aniversario: string;
  message?: string;
}

let WIN_PREV_POSITION = window.scrollY;

const Header3: FC<Header3Props> = ({ className = "", searchEngine }) => {
  const headerInnerRef = useRef<HTMLDivElement>(null);
  const {
    showHeroSearch,
    setShowHeroSearch,
    setSubmitSearchHotels,
    setDestination,
    setDestinationName,
    setNumNights,
    loading,
    setPageReload,
    setHotelSearchFirst,
    setHiddenHero,
    setSearchEngine,
  } = useHotels();
  const [currentTab, setCurrentTab] = useState<SearchTab>("Hotéis");
  const { profile } = useMetadataUser();

  const profileWalletAndSubscription = (profile: RootProfile | null): boolean => {
    if (!profile) {
      return false;
    }

    const { subscription, wallet } = profile;

    if (subscription && subscription.active && wallet.balance >= 0) {
      return true;
    }

    if (wallet.balance > 0) {
      return true;
    }

    return false;
  };


  useOutsideAlerter(headerInnerRef, () => {
    setShowHeroSearch(null);
    setCurrentTab("Hotéis");
  });

  let location = useLocation();
  //

  useEffect(() => {
    setShowHeroSearch(null);
  }, [location]);

  // HIDDEN WHEN SCROLL EVENT
  useEffect(() => {
    window.addEventListener("scroll", handleEvent);
    return () => {
      window.removeEventListener("scroll", handleEvent);
    };
  }, []);

  const handleEvent = () => {
    window.requestAnimationFrame(handleHideSearchForm);
  };

  const handleClick = (param: StaySearchFormFields) => {
    setShowHeroSearch(param);
  };

  const handleHideSearchForm = () => {
    if (!document.querySelector("#nc-Header-3-anchor")) {
      return;
    }
    //
    let currentScrollPos = window.scrollY;
    if (
      WIN_PREV_POSITION - currentScrollPos > 100 ||
      WIN_PREV_POSITION - currentScrollPos < -100
    ) {
      setShowHeroSearch(null);
    } else {
      return;
    }
    WIN_PREV_POSITION = currentScrollPos;
  };

  const renderHeroSearch = () => {
    return (
      <div
        className={`absolute inset-x-0 top-0 transition-all will-change-[transform,opacity] ${searchEngine && showHeroSearch
          ? "visible"
          : "-translate-x-0 -translate-y-[90px] scale-x-[0.395] scale-y-[0.6] opacity-0 invisible pointer-events-none"
          }`}
      >
        <div className={`w-full max-w-5xl mx-auto pb-6`}>
          <HeroSearchFormSmall
            defaultFieldFocus={showHeroSearch || undefined}
            onTabChange={setCurrentTab}
            defaultTab={currentTab}
          />
        </div>
      </div>
    );
  };

  const renderButtonOpenHeroSearch = () => {
    return (
      <div
        className={`w-full relative flex items-center justify-between border border-neutral-200 dark:border-neutral-6000 rounded-full shadow hover:shadow-md transition-all ${searchEngine && showHeroSearch
          ? "-translate-x-0 translate-y-20 scale-x-[2.55] scale-y-[1.8] opacity-0 pointer-events-none invisible"
          : "visible"
          }`}
      >
        <div className="flex items-center font-medium text-sm">
          <span
            onClick={() => handleClick("location")}
            className={`block pl-5 pr-4 cursor-pointer py-3 ${loading ? "pointer-events-none" : "pointer-events-auto"
              }`}
          >
            Destino
          </span>
          <span className="h-5 w-[1px] bg-neutral-300 dark:bg-neutral-700"></span>
          <span
            onClick={() => handleClick("dates")}
            className={`block px-4 cursor-pointer py-3
              ${loading ? "pointer-events-none" : "pointer-events-auto"}`}
          >
            Check In
          </span>
          <span className="h-5 w-[1px] bg-neutral-300 dark:bg-neutral-700"></span>
          <span
            onClick={() => handleClick("guests")}
            className={`block px-4 cursor-pointer font-normal py-3
              ${loading ? "pointer-events-none" : "pointer-events-auto"}`}
          >
            Hóspedes
          </span>
        </div>

        <button
          className={`flex-shrink-0 ml-auto pr-2 cursor-pointer
            ${loading ? "pointer-events-none" : "pointer-events-auto"}`}
          onClick={() => {
            if (!loading) {
              handleClick("location");
            }
          }}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-[--green]  text-white">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M19.25 19.25L15.5 15.5M4.75 11C4.75 7.54822 7.54822 4.75 11 4.75C14.4518 4.75 17.25 7.54822 17.25 11C17.25 14.4518 14.4518 17.25 11 17.25C7.54822 17.25 4.75 14.4518 4.75 11Z"
              ></path>
            </svg>
          </span>
        </button>
      </div>
    );
  };

  return (
    <>
      <div
        className={`nc-Header nc-Header-3 fixed z-40 top-0 inset-0 bg-black/30 dark:bg-black/50 transition-opacity will-change-[opacity] ${searchEngine && showHeroSearch ? "visible" : "invisible opacity-0 pointer-events-none"}`}
      ></div>
      {searchEngine && showHeroSearch && <div id="nc-Header-3-anchor"></div>}
      <header ref={headerInnerRef} className={`sticky top-0 z-40 ${className}`}>
        <div
          className={`bg-white dark:bg-neutral-900 absolute h-full inset-x-0 top-0 transition-transform will-change-[transform,opacity]
          ${searchEngine && showHeroSearch ? "duration-75" : ""} 
          ${searchEngine && showHeroSearch
              ? currentTab === "Cars" || currentTab === "Passagens"
                ? "scale-y-[4.4]"
                : "scale-y-[3.4]"
              : ""
            }`}
        ></div>
        <div className="relative px-4 lg:container h-[88px] flex">
          <div className="flex-1 flex items-center justify-between">
            {/* Logo (lg+) */}
            <div className="relative z-10 hidden md:flex flex-1">
              <Link
                to="/"
                onClick={() => {
                  window.scrollTo(0, 0);
                  setSubmitSearchHotels(false);
                  setDestination(1010394);
                  setDestinationName("");
                  setNumNights(1);
                  setPageReload(false);
                  setHotelSearchFirst(null);
                  setHiddenHero(true);
                  setSearchEngine(false);
                }}
              >
                <Logo searchEngine={searchEngine} />
              </Link>
            </div>

            {searchEngine && (
              <div className="flex-[2] lg:flex-none mx-auto">
                <div className="hidden lg:block">
                  {renderButtonOpenHeroSearch()}
                </div>
                <div className="lg:hidden w-full max-w-lg mx-auto">
                  <HeroSearchForm2MobileFactory />
                </div>
                {renderHeroSearch()}
              </div>
            )}

            {/* NAV */}
            <div className="hidden md:flex relative z-10 flex-1 items-center justify-end text-neutral-700 dark:text-neutral-100">
              <div className="items-center flex space-x-1">
                <div className="flex items-center justify-center gap-4">
                  {profile?.subscription?.active ? (
                    <p className="text-sm font-semibold">
                      Plano:{" "}
                      {profile?.subscription
                        ? profile?.subscription.plan_name
                        : "Indisponível"}
                    </p>
                  ) : null}
                  {(
                    profileWalletAndSubscription(profile) ? (
                      <p className="text-sm font-semibold flex gap-1 justify-center items-center">
                        <FaWallet size={16} />
                        <span>
                          ViroCash:{" "}
                          {profile?.wallet
                            ? new Intl.NumberFormat('pt-BR').format(profile?.wallet.balance)
                            : "Indisponível"}
                        </span>
                      </p>
                    ) : null
                  )}
                </div>
                <SwitchDarkMode />
                {searchEngine || window.location.pathname === "/home" ? (
                  <AvatarDropdown />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header3;
